// extracted by mini-css-extract-plugin
export default {"container":"left_side_container__Fh0yg","language_container":"left_side_language_container__utyb4","language":"left_side_language__Ienqh","close":"left_side_close__-b3RW"};